// extracted by mini-css-extract-plugin
module.exports = {"mobile-child-menu-item":"ChildMenuItemModule_mobile-child-menu-item__1K91z","active":"ChildMenuItemModule_active__312HY","right-arrow":"ChildMenuItemModule_right-arrow__3oFHI"};